import TagManager from 'react-gtm-module'
import { getLogger } from '../logger'
import type { DataLayer } from './models-gtm'
import { ConcessionsGtmEvents } from './types/ecommerce/concessions.gtm'
import { FilmsGtmEvents } from './types/ecommerce/films.gtm'
import { FnbGtmEvents } from './types/ecommerce/fnb.gtm'
import { GiftsGtmEvents } from './types/ecommerce/gifts.gtm'
import { PaymentGtmEvents } from './types/ecommerce/payment.gtm'
import { TicketsGtmEvents } from './types/ecommerce/tickets.gtm'

export class GtmService {
    protected logger = getLogger('GtmService')
    private initialized = false

    public initializeGoogleTags(gtmId: string) {
        if (this.initialized) {
            this.logger.value.warn('GTM already initialized')
            return
        }

        const tagManagerArgs = {
            gtmId: gtmId,
        }

        if (gtmId && gtmId.length > 0) {
            TagManager.initialize(tagManagerArgs)
            this.initialized = true
        }
    }

    public sendDataLayer(dataLayerObj: DataLayer) {
        // Tracking data for testing purposes
        this.logger.value.debug('Sending data layer', dataLayerObj)

        TagManager.dataLayer({ dataLayer: dataLayerObj })
    }

    public ecommerce: {
        films?: FilmsGtmEvents
        gifts?: GiftsGtmEvents
        fnb?: FnbGtmEvents
        concessions?: ConcessionsGtmEvents
        tickets?: TicketsGtmEvents
        payment?: PaymentGtmEvents
    }
    public constructor() {
        this.ecommerce = {
            films: FilmsGtmEvents,
            gifts: GiftsGtmEvents,
            fnb: FnbGtmEvents,
            concessions: ConcessionsGtmEvents,
            tickets: TicketsGtmEvents,
            payment: PaymentGtmEvents,
        }
    }
}

export const gtm = new GtmService()
